export function FileBox() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="65" height="64" viewBox="0 0 65 64" fill="none">
      <rect x="0.5" width="64" height="64" rx="10.0299" fill="#262626" />
      <path d="M45.7496 30.0234V40.281L33.709 46.993V29.042L36.2021 34.092L45.7496 30.0234Z" fill="white" />
      <path d="M32.2916 29.042V47.0001L20.251 40.281V30.0234L29.7985 34.092L32.2916 29.042Z" fill="white" />
      <path d="M48.9997 27.0856L36.8812 32.2431L33.9844 26.3979L46.1312 21.835L48.9997 27.0856Z" fill="white" />
      <path d="M32.0154 26.3979L29.1185 32.2431L17 27.0856L19.8685 21.835L32.0154 26.3979Z" fill="white" />
      <path d="M44.4039 20.9541L33.709 24.9726V17L44.4039 20.9541Z" fill="white" />
      <path d="M32.2916 17V24.9726L21.5967 20.9541L32.2916 17Z" fill="white" />
    </svg>
  );
}
